<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="预警规则名称" prop="alarmRuleName">
            <el-input
              clearable
              v-model="formData.alarmRuleName"
              placeholder="请输入预警规则名称"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="消息模板" prop="msgTemplateCode">
            <dict-select
              filterable
              v-model="formData.msgTemplateCode"
              url="/sys/alarm/template/select"
              placeholder="请选择消息模板"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="推送方式" prop="sendType">
            <el-select
              v-model="formData.sendType"
              placeholder="请选择推送方式"
              style="width:100%"
            >
              <el-option label="短信" value="SMS" />
              <el-option label="邮件" value="mail" />
              <el-option label="微信推送" value="wechat" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="业务表单" prop="tableName">
            <dict-select
              filterable
              v-model="formData.tableName"
              placeholder="请选择业务表单"
              default
              :body="tableNameDictParams"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="匹配方式" prop="matchCondition">
            <el-select
              v-model="formData.matchCondition"
              placeholder="请选择匹配方式"
              style="width:100%"
              clearable
            >
              <el-option label="等于" value="equal" />
              <el-option label="大于" value="greaterThan" />
              <el-option label="小于" value="lessThan" />
              <el-option label="范围值" value="in" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="表单字段" prop="tableColumnName">
            <dict-select
              filterable
              v-model="formData.tableColumnName"
              placeholder="请输入表单字段"
              default
              :body="tableColumnNameDictParams"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-form-item label="匹配值" prop="matchValue">
          <el-input
            clearable
            v-model="formData.matchValue"
            placeholder="请输入匹配值"
            type="textarea"
          >
          </el-input>
        </el-form-item>
      </el-row>

      <el-row>
        <el-form-item label="通知范围" prop="sendWho">
          <el-input
            clearable
            v-model="formData.sendWho"
            placeholder="请输入通知范围用逗号隔开"
            type="textarea"
          >
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="启用状态" prop="alarmRuleStatus">
          <el-radio-group v-model="formData.alarmRuleStatus">
            <el-radio label="Y">已启用</el-radio>
            <el-radio label="N">未启用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    alarmRuleCode: String,
  },
  data() {
    return {
      tableNameDictParams: { type: 'tableName' },
      tableColumnNameDictParams: { type: 'tableColumnName' },
      backDialogVisible: false,
      formData: { alarmRuleStatus: 'Y' },
      rules: {
        alarmRuleName: [
          {
            required: true,
            message: '请输入预警规则名称',
            trigger: 'blur',
          },
        ],
        sendType: [
          {
            required: true,
            message: '请选择推送方式',
            trigger: 'change',
          },
        ],
        msgTemplateCode: [
          {
            required: true,
            message: '请选择消息模板',
            trigger: 'change',
          },
        ],
        tableName: [
          {
            required: true,
            message: '请输入业务表单',
            trigger: 'blur',
          },
        ],
        tableColumnName: [
          {
            required: true,
            message: '请输入表单字段',
            trigger: 'blur',
          },
        ],
        matchCondition: [
          {
            required: true,
            message: '请选择匹配方式',
            trigger: 'change',
          },
        ],
        matchValue: [
          {
            required: true,
            message: '请输入匹配值',
            trigger: 'blur',
          },
        ],
        sendWho: [
          {
            required: true,
            message: '请输入通知范围',
            trigger: 'blur',
          },
        ],
        alarmRuleStatus: [
          {
            required: true,
            message: '请选择启用状态',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.alarmRuleCode) return
      this.$api
        .sysAlarmRuleDetailApi({
          alarmRuleCode: this.alarmRuleCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .sysAlarmRuleSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
